<template>
    <div class="bg-white p-4">
        <div class="flex items-center justify-between mb-3">
            <b>
                View all your past dispatcher ratings
            </b>
            <span>
                <el-dropdown trigger="click" class="h-full w_semi">
                    <div class="drp-content">
                        <span>
                            <img src="@/views/3pl/BillingandCollection/icons/CalendarIcon.svg" />
                            <abbr class="vrt_line"></abbr>
                            <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
                        </span>
                        <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <button @click="setFilterType('today', 'Today')">Today</button>
                        </el-dropdown-item>

                        <el-dropdown-item>
                            <button @click="setFilterType('this_week', 'This Week')">This week</button>
                        </el-dropdown-item>

                        <el-dropdown-item>
                            <button @click="setFilterType('this_month', 'This Month')">This month</button>
                        </el-dropdown-item>

                        <el-dropdown-item>
                            <button @click="setFilterType('this_year', 'This Year')">This year</button>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <button @click="setFilterType('all_time', 'All time')">All time</button>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </span>
        </div>
        <EmptyRatings v-if="ratingHistory.length < 1" />
        <div class=" light_bg p-3 rounded-md" v-else>
            <div class="w-full mt-2 rate_div" v-for="item, index in ratingHistory" :key="index = 'dleiver_rate'">
                <div class="flex items-center justify-between">
                    <span>{{ item.tags ? item.tags[0] : 'N/A' }}</span>
                    <span class="inline-flex items-center gap-2">
                        <star-rate :canChange="false" :value="item.rating" :size="14"></star-rate> {{ item.rating }}.0
                    </span>
                </div>
                <p class="text-sm text-gray-500 py-2">{{ item.comment || 'N/A' }}</p>
                <div class="flex items-center gap-3">
                    <img class="w-5 h-5 rounded-full "
                        :src="item.ratedUser && item.ratedUserimageurl ? item.ratedUser : ''" alt="" /> <span
                        class="text-sm">
                        {{ item.ratedUser && item.ratedUser.firstname ? item.ratedUser.firstname.substring(0, 3) :
                            '' }}*** ***</span>
                </div>
                <hr class="my-1 mt-3 mb-3" />
            </div>
        </div>
    </div>
</template>

<script>
import EmptyRatings from './empty-ratings.vue';
import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";

export default {
    components: {
        EmptyRatings,
        ArrowDownBlackIcon
    },
    props: {

    },
    methods: {
        setFilterType(val, title) {
            this.interval = val
            this.filterTitle = title
        },
        async getUserRatingsHistory() {
            try {
                let response = await this.$_getUserRatingsHistory(this.params);
                this.ratingHistory = response?.data?.ratingHistory
            } catch (error) {
                //
            }
        }
    },
    mounted() {
        this.getUserRatingsHistory()
    },
    computed: {
        params() {
            return this.interval
        }
    },
    watch: {
        interval() {
            this.getUserRatingsHistory()
        }
    },
    data() {
        return {
            ratingHistory: [],
            interval: "this_month",
            filterTitle: "This Month"
        };
    },
}
</script>

<style lang="scss" scoped>
.progress {
    width: 400px;
    height: 40px;

    &>span {
        display: block;
        height: 100%;
        @apply bg-primary-green;
    }
}

.rate_div:nth-last-of-type(1) {
    hr {
        @apply hidden
    }
}

.light_bg {
    @apply bg-primary-blue/5
}

.w_semi {
    @apply w-[200px] flex items-center
}

.drp-content {
    @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

    span {
        @apply flex items-center
    }
}

.vrt_line {
    @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
</style>